import { useEffect, useRef } from "react"
import { message } from "antd"
import STORAGE from "src/lib/storage"

const PermissionGuard = ({ permission,showMessage , children, fallback = null }) => {
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const hasPermission = permissions.includes(permission)

  const shownRef = useRef(false)

  useEffect(() => {
    if (!hasPermission && !shownRef.current) {
      if(showMessage){ message.error("Không có quyền truy cập")}
      shownRef.current = true
    }
  }, [hasPermission])

  if (!hasPermission) return fallback

  return children
}

export default PermissionGuard
